module.exports = __webpack_public_path__ + "img/188.123e0f73.jpg";